import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';
import { hasModuleAccess } from 'utils/roleWeights';

// ==============================|| REQUIRE MODULE ACCESS GUARD ||============================== //
// Generic replacement for the old RequireSystemAdmin (2026-08-22, "core_modules"
// katalog) - takes a moduleKey/minRole pair (matching a real, admin-managed
// core_modules entry) instead of a hardcoded flag, so any new section works
// the same way without a bespoke guard component. Compares against
// /auth/me's `permissions` array (hasModuleAccess() - includes the
// superadmin bypass). Nests inside AuthGuard (caller is already known to be
// logged in).
//
// NOT used for Uživatelé/Skupiny - those are gated by group-admin
// DELEGATION (core_group_admins), a separate concept from a module_key
// permission grant, see RequireAdminAccess.jsx.
//
// `requirePayrollGrant` (2026-09-01, na výslovné přání uživatele - "Mzdová
// účetní" stránky/sekce smí vidět jen mzdová účetní nebo správce, ne
// vedoucí pobočky") - volitelné, default false. Kontroluje
// `/auth/me`'s `attendance_payroll_access` (AuthController.php,
// PermissionService::visibleUserIdsFor() - null = neomezený dosah), ne
// moduleKey/minRole - regional_manager samo o sobě vedoucího pobočky od
// mzdové účetní neodliší (obě drží stejnou roli, rozdíl je scope_group_id,
// který se do `permissions` vůbec nepromítá).

export default function RequireModuleAccess({ moduleKey, minRole, requirePayrollGrant = false, children }) {
  const { status, user } = useAuth();

  if (status === 'loading') return <Loader />;

  if (!hasModuleAccess(user?.permissions, moduleKey, minRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requirePayrollGrant && !user?.attendance_payroll_access) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

RequireModuleAccess.propTypes = {
  moduleKey: PropTypes.string.isRequired,
  minRole: PropTypes.string.isRequired,
  requirePayrollGrant: PropTypes.bool,
  children: PropTypes.node
};
